import { render, staticRenderFns } from "./WithdrawalExplain.vue?vue&type=template&id=3c6c2383&scoped=true&"
import script from "./WithdrawalExplain.vue?vue&type=script&lang=js&"
export * from "./WithdrawalExplain.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalExplain.vue?vue&type=style&index=0&id=3c6c2383&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c2383",
  null
  
)

export default component.exports